import { fetchFAQProgram, deleteFAQProgram } from 'Features/Learning/FAQProgram/Utils/FAQProgramUtils';
import { handleDeleteConfirmation } from 'Utils/handleDelete';

/* **************************************************** */
/* CRUD FAQProgram                                       */
/* **************************************************** */

export const fetchFAQPrograms = (dispatch, filters, refatch) => {
  dispatch(fetchFAQProgram(filters));
};

export const handleDeleteFAQProgram = async (dispatch, id, setRefetch) => {
  handleDeleteConfirmation({
    dispatch,
    id,
    setRefetch,
    deleteAction: deleteFAQProgram,
  });
};

export const handleEditFAQProgram = async (dispatch, item, setField, toggle) => {
  dispatch(setField({ field: 'question', value: item?.question }));
  dispatch(setField({ field: 'answer', value: item?.answer }));
  dispatch(setField({ field: 'is_show', value: item?.is_show }));
  dispatch(setField({ field: 'isUpdate', value: true }));
  dispatch(setField({ field: 'id', value: item?.id }));
  toggle();
};

export const handleGetDetailFAQProgram = async (dispatch, item, setDetail) => {
  dispatch(setDetail(item));
};

/* **************************************************** */
/* Pagination                                           */
/* **************************************************** */

export const handleBackPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page > 1) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page - 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleNextPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page < pagination.last_page) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page + 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleClickPagination = (page, filters, dispatch, setFilters, setRefetch) => {
  console.log(page);
  dispatch(setFilters({
    ...filters,
    page: page
  }));
  setRefetch(prevRefetch => !prevRefetch);
}